"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.updateRecipientPreferences = exports.getDraftPreferencePage = exports.getPreferencePage = exports.getRecipientPreferences = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _client = require("./client");

var RECIPIENT_PREFERENCES = "\n  query GetRecipientPreferences {\n    recipientPreferences {\n      nodes {\n        templateId\n        status\n        hasCustomRouting\n        routingPreferences\n        digestSchedule\n      }\n    }\n  }\n";
var PREFERENCE_PAGE = "\n  query($accountId: String) {\n    preferencePage(accountId: $accountId) {\n      showCourierFooter\n      brand {\n        settings {\n          colors {\n            primary\n          }\n        }\n        links\n        logo {\n          href\n          image\n        }\n      }\n      sections {\n        nodes {\n          name\n          sectionId\n          routingOptions\n          hasCustomRouting\n          topics {\n            nodes {\n              defaultStatus\n              templateName\n              templateId\n              digestSchedules\n            }\n          }\n        }\n      }\n    }\n  }\n";
var DRAFT_PREFERENCE_PAGE = "\n  query {\n    draftPreferencePage {\n      showCourierFooter\n      brand {\n        settings {\n          colors {\n            primary\n          }\n        }\n        links\n        logo {\n          href\n          image\n        }\n      }\n      sections {\n        nodes {\n          name\n          sectionId\n          routingOptions\n          hasCustomRouting\n          topics {\n            nodes {\n              defaultStatus\n              templateName\n              templateId\n              digestSchedules\n            }\n          }\n        }\n      }\n    }\n  }\n";

var getRecipientPreferences = function getRecipientPreferences(client) {
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _results$data;

    var results;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (client) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return client.query(RECIPIENT_PREFERENCES).toPromise();

          case 4:
            results = _context.sent;
            return _context.abrupt("return", (_results$data = results.data) === null || _results$data === void 0 ? void 0 : _results$data.recipientPreferences.nodes);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.getRecipientPreferences = getRecipientPreferences;

var getPreferencePage = function getPreferencePage(client) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(accountId) {
      var _results$data2;

      var results;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (client) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return client.query(PREFERENCE_PAGE, {
                accountId: accountId
              }).toPromise();

            case 4:
              results = _context2.sent;
              return _context2.abrupt("return", (_results$data2 = results.data) === null || _results$data2 === void 0 ? void 0 : _results$data2.preferencePage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.getPreferencePage = getPreferencePage;

var getDraftPreferencePage = function getDraftPreferencePage(client) {
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var _results$data3;

    var results;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (client) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return client.query(DRAFT_PREFERENCE_PAGE).toPromise();

          case 4:
            results = _context3.sent;
            return _context3.abrupt("return", (_results$data3 = results.data) === null || _results$data3 === void 0 ? void 0 : _results$data3.draftPreferencePage);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.getDraftPreferencePage = getDraftPreferencePage;
var UPDATE_RECIPIENT_PREFERENCES = "\n  mutation UpdateRecipientPreferences($id: String!, $preferences: PreferencesInput!) {\n    updatePreferences(templateId: $id preferences: $preferences)\n  }\n";

var updateRecipientPreferences = function updateRecipientPreferences(client) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(payload) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (client) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return", Promise.resolve());

            case 2:
              _context4.next = 4;
              return client.mutation(UPDATE_RECIPIENT_PREFERENCES, {
                id: payload.templateId,
                preferences: {
                  status: payload.status,
                  hasCustomRouting: payload.hasCustomRouting,
                  routingPreferences: payload.routingPreferences,
                  digestSchedule: payload.digestSchedule
                }
              }).toPromise();

            case 4:
              return _context4.abrupt("return", payload);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.updateRecipientPreferences = updateRecipientPreferences;

var _default = function _default(params) {
  var client = (0, _client.createCourierClient)(params);
  return {
    getRecipientPreferences: getRecipientPreferences(client),
    getPreferencePage: getPreferencePage(client),
    getDraftPreferencePage: getDraftPreferencePage(client),
    updateRecipientPreferences: updateRecipientPreferences(client)
  };
};

exports["default"] = _default;